import i18n from "../../../i18n";
import { Notification } from "../../../Utils/Notification";
import { UpdatePinOnMainPlan, UpdatePinOnMainPlanCreatePolygon } from "../../../Utils/UpdateMainPlanData";

export const updatePinSetting = (state, action) => {
  if (action.value === state.PinSetting[action.key]) {
    return state;
  }
  const updateValue = {
    ...state.PinSetting,
    [action.key]: action.value,
  };
  return { ...state, PinSetting: updateValue };
};

const pinIsOnMultiSelectMode = (
  pin,
  state,
  updatePinSetting,
  updateMainPlanData
) => {
  if (pin.isMultiSelect) { // if pin is in multiselect mode now
    // turn off pin from multiSelect and remove it from MS pins list
    updatePinSetting.MultiSelect = updatePinSetting.MultiSelect.filter(MSPin => MSPin.packetId !== pin.packetId);
  } else {
    updatePinSetting.MultiSelect = [...updatePinSetting.MultiSelect, pin]; // add pin to multiSelect pins array
  }
  pin.isMultiSelect = !Boolean(pin.isMultiSelect); // change  isMultiSelect flag
  const newPlanData = UpdatePinOnMainPlan(
    state.mainPlanData,
    pin,
    "isMultiSelect"
  );
  updateMainPlanData.polygons = newPlanData.polygons;
};

export const selectPin = (state, action) => {

  if (state.PinSetting.ReAssign) {
    Notification.pushNotif(i18n.t("Notification.SelectPolygonForAssign"), 'warning')
    return { ...state };
  };
  if (state.MenuItems.multiSelect) {
    if (state.MenuItems.resequence === 2 || state.PlanReset.request) { // in multiselectMode and resequencing or request to Reseq
      Notification.pushNotif(i18n.t("Notification.WaitEndProccess"), "error");
      return { ...state }
    }
  }
  const updatePolygonSetting = { ...state.PolygonSetting };
  const updateMenuItem = { ...state.MenuItems, drawer: true };
  const updateMapItems = {
    ...state.MapItems,
    selectedPin: action.pin,
  };
  let updatePinSetting = {
    ...state.PinSetting,
    showListOfPolygonPins: false,
  };
  let updateMainPlanData = { ...state.mainPlanData };


  if (action.pin) { // if pin is selected
    if (
      state.cantDoEditAfterGetExternal &&
      action.pin?.sentByGetExternal &&
      state.MenuItems.createPoly
    ) {
      Notification.pushNotif(
        i18n.t("Notification.CantEditAfterGetExternal"),
        "error"
      );
      return { ...state };
    }
    if (state.MenuItems.createPoly) {
      // action.pin.newPolygon = !Boolean(action.pin.newPolygon); // change  new polygon flag
      // action.pin.isChanged = !Boolean(action.pin.isChanged); // change  new polygon flag
      const newPlanData = UpdatePinOnMainPlanCreatePolygon(
        state.mainPlanData,
        action.pin,
      );
      updateMainPlanData.polygons = newPlanData.polygons;
      // const updateNewPolygon = [...state.PinSetting.CreatePolygon, action.pin]
      return {
        ...state,
        PinSetting: {
            ...state.PinSetting,
            ...(action.flyToPin ? {flyToPin: action.pin.coordinates} : {})
        },
        // PinSetting: {
        //   ...state.PinSetting,
        //   CreatePolygon: updateNewPolygon
        // },
        mainPlanData: updateMainPlanData,
      };
    };

    if (action.flyToPin) { // if it's not in multiselect and flyToPin is true (by default fly to pin is true) -> fly to pin
      updatePinSetting.flyToPin = action.pin.coordinates;
    };

    if (state.MenuItems.multiSelect) { // if it's on multiSelect mode
      if (
        state.cantDoEditAfterGetExternal &&
        action.pin?.sentByGetExternal &&
        !action.pin.isMultiSelect
      ) {
        Notification.pushNotif(
          i18n.t("Notification.CantEditAfterGetExternal"),
          "error"
        );
        return { ...state };
      }
      pinIsOnMultiSelectMode(action.pin, state, updatePinSetting, updateMainPlanData);
    };

    if (state.FilteredPolygons.polygons) { // set 'SelectedPolygon' to polygon which has this selectedPin
      const { uid } = action.pin;
      const polygon = state.FilteredPolygons.polygons.find(poly => poly.subPlan.uid === uid);

      if (
        !Boolean(state.MapItems.selectedPolygon) // if there is no polygon in selected polyogn
        ||
        state.MapItems.selectedPolygon.subPlan.uid !== uid // OR the selectedPolygon is not this polygon
      ) {
        updateMapItems.selectedPolygon = polygon;
        updatePolygonSetting.showListOfPolygons = false;  // dont show list of polygons
        if (updateMenuItem.polygonPins === 0) { // if polygon pins is not clickable
          updateMenuItem.polygonPins = 1;
        }
      }
    };
  };

  return {
    ...state,
    planViewMapDrawerTab: 2,
    MapItems: updateMapItems,
    MenuItems: updateMenuItem,
    PinSetting: updatePinSetting,
    mainPlanData: updateMainPlanData,
    PolygonSetting: updatePolygonSetting,
  };
};

const getAllCoords = (addresses, remainPin) => { // get useful coords (without same coords and include address)

  const difference = (a, b) => { // calculate distance between two pins
    return Math.abs(a - b);
  };

  const isAddressTextExist = (addressText, fullAddress) => {
    let replaceAddress;
    replaceAddress = addressText.replaceAll(',', ''); // remove , from address
    replaceAddress = addressText.replaceAll('-', ''); // remove - from address
    replaceAddress = replaceAddress.trim(); // remove spaces from address
    let sepAddress = replaceAddress.split(" ");

    if (sepAddress.length > 3) { // if address is too long bring first of it
      sepAddress = sepAddress.slice(0, 2);
    };

    const filteredAddress = sepAddress.filter(word => fullAddress.includes(word));

    if (difference(filteredAddress.length, sepAddress.length) <= 2) { // this mean all of word in array is exist in sepAddress
      return true;
    }
    return false;
  };

  const checkIfAddressIsNotExist_AddIt = (address) => {
    if (goodAddressToRemain.length) {
      const addressExists = goodAddressToRemain.find(goodAddress => {
        const latDiff = difference(goodAddress.lat, address.latitude);
        const lonDiff = difference(goodAddress.lon, address.longitude);
        if (latDiff < .06 && lonDiff < .06) {
          return true;
        };
        return false;
      });
      if (!addressExists) {
        goodAddressToRemain.push({ lat: address.latitude, lon: address.longitude });
      };
    } else {
      goodAddressToRemain.push({ lat: address.latitude, lon: address.longitude });
    };
  }

  const goodAddressToRemain = [];

  addresses.forEach(address => {
    if (address.score < 60) {
      if (isAddressTextExist(remainPin.address, address.address)) {
        checkIfAddressIsNotExist_AddIt(address);
      };
    } else {
      checkIfAddressIsNotExist_AddIt(address);
    }
  });

  if (goodAddressToRemain.length) {
    return goodAddressToRemain;
  };
  return [{ lat: addresses[0].latitude, lon: addresses[0].longitude }];
};


export const getRemainCoord = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, RemainPinCoord: updateValue };
};
export const getRemainCoordSuccess = (state, action) => {
  const CoordsSearchedToRemain = getAllCoords(action.res, state.PinSetting.AssignRemainPin[0])
  const updateValue = {
    request: null,
    response: CoordsSearchedToRemain,
    error: null,
  };

  Notification.pushNotif(i18n.t("Notification.selectPinOnMap", "info", 7000))

  return {
    ...state,
    RemainPinCoord: updateValue,
    PolygonSetting: {
      ...state.PolygonSetting,
      flyToCoords: CoordsSearchedToRemain // fly to location pins
    },
  };
};
export const getRemainCoordFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, RemainPinCoord: updateValue };
};


export const uploadLastPin = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, LastPin: updateValue };
};
export const uploadLastPinSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  return { ...state, LastPin: updateValue ,PlanHasLastPin:true};
};
export const uploadLastPinFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, 'error');
  return { ...state, LastPin: updateValue };
};


export const confirmLastPin = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, ConfirmLastPin: updateValue };
};
export const confirmLastPinSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  return {
    ...state,
    ConfirmLastPin: updateValue,
    PlanHasLastPin: false // hide confirmation last pin button
  };
};
export const confirmLastPinFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, 'error');
  return { ...state, ConfirmLastPin: updateValue };
};
